import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import momentPropTypes from 'react-moment-proptypes';
import { PropType as PolygotPropType } from 'redux-polyglot';
import ChartCard from 'components/ChartCard';

import GenderChart from './gender';

const Gender = ({
  p, match, startDate, endDate,
}) => (
  <div>
    <Row>
      <Col span={24}>
        <ChartCard title={p.tt('audience.visitors_by_gender')}>
          <GenderChart
            zoneId={match.params.zone_id}
            p={p}
            startDate={startDate}
            endDate={endDate}
          />
        </ChartCard>
      </Col>
    </Row>
  </div>
);

Gender.propTypes = {
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
  match: PropTypes.object,
  p: PolygotPropType,
};

export default Gender;
